module.exports = __webpack_public_path__ + "static/media/polygon-hermez-logo.44364ebc.png";